export const initNavigation2 = () => {
    console.log('Header 2 navigation initialized')
    // Header 2 specific navigation implementation
}
